// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-bar {
  background-color: var(--ion-color-light);
  height: 3.5rem;
  justify-content: space-around;
  flex-wrap: nowrap;
  display: flex;
  padding-bottom: calc(env(safe-area-inset-bottom) / 2);
}
.navigation-bar ::ng-deep .navigation-bar-item {
  padding-bottom: 0;
}
@media (orientation: portrait) and (max-width: 576px) {
  .navigation-bar ::ng-deep .navigation-bar-item {
    width: auto;
  }
}
.navigation-bar ::ng-deep .navigation-bar-item::after {
  display: none !important;
  content: unset !important;
}
.navigation-bar ::ng-deep .navigation-bar-item .navigation-bar-item__name {
  color: var(--bottom-menu-color);
}
.navigation-bar ::ng-deep .navigation-bar-item .navigation-bar-item__icon {
  filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(82deg) brightness(97%) contrast(87%);
}
.navigation-bar ::ng-deep .navigation-bar-item--is-active .navigation-bar-item__name {
  color: var(--ion-color-secondary) !important;
}
.navigation-bar ::ng-deep .navigation-bar-item--is-active .navigation-bar-item__icon {
  filter: brightness(0) saturate(100%) invert(30%) sepia(94%) saturate(1528%) hue-rotate(353deg) brightness(101%) contrast(109%) !important;
}
.navigation-bar .ion-tab-button-light {
  --background: var(--ion-color-light);
}

.android-bottom-bar {
  padding-bottom: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-bar/bottom-bar/bottom-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,wCAAA;EACA,cAAA;EACA,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,qDAAA;AACJ;AACI;EACI,iBAAA;AACR;AACQ;EAHJ;IAIQ,WAAA;EAEV;AACF;AAAQ;EACI,wBAAA;EACA,yBAAA;AAEZ;AACQ;EACI,+BAAA;AACZ;AAEQ;EACI,uHAAA;AAAZ;AAIY;EACI,4CAAA;AAFhB;AAKY;EACI,yIAAA;AAHhB;AAQI;EACI,oCAAA;AANR;;AAUA;EACI,8BAAA;AAPJ","sourcesContent":[".navigation-bar {\r\n    background-color: var(--ion-color-light);\r\n    height: 3.5rem;\r\n    justify-content: space-around;\r\n    flex-wrap: nowrap;\r\n    display: flex;\r\n    padding-bottom: calc(env(safe-area-inset-bottom) / 2);\r\n\r\n    ::ng-deep .navigation-bar-item {\r\n        padding-bottom: 0;\r\n\r\n        @media (orientation: portrait) and (max-width: 576px) {\r\n            width: auto;\r\n        }\r\n\r\n        &::after {\r\n            display: none !important;\r\n            content: unset !important;\r\n        }\r\n\r\n        .navigation-bar-item__name {\r\n            color: var(--bottom-menu-color);\r\n        }\r\n\r\n        .navigation-bar-item__icon {\r\n            filter: brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(82deg) brightness(97%) contrast(87%);\r\n        }\r\n\r\n        &--is-active {\r\n            .navigation-bar-item__name {\r\n                color: var(--ion-color-secondary) !important;\r\n            }\r\n\r\n            .navigation-bar-item__icon {\r\n                filter: brightness(0) saturate(100%) invert(30%) sepia(94%) saturate(1528%) hue-rotate(353deg) brightness(101%) contrast(109%) !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .ion-tab-button-light {\r\n        --background: var(--ion-color-light);\r\n    }\r\n}\r\n\r\n.android-bottom-bar {\r\n    padding-bottom: 0px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
